import 'bootstrap/dist/css/bootstrap.min.css'; 
import hii from '../assets/img/hii.gif'
import Navbar from './NavBar.js'
import Roll from 'react-reveal/Roll';

function ContactHeroSection() {
    return (
        <div className="sec6 container">
            <Navbar />
            <h2>Contact me</h2>
            <Roll left>
            <div className="row aboutSection">
              <div className="col">
                <p>
                    Hello, <br></br>
                    Are you looking for me ? <br></br>
                    Do you want to work together? <br></br>
                    Open to work part time :)<br></br>
                    Let's meet up !
                </p>
              </div>
              <div className="col">
              <img src={hii} alt="line" />
              </div>
            </div>
            </Roll>
          </div>
        );
    }
    
export default ContactHeroSection;